import React from 'react';
import {useControllerProps} from '../../../../../../../domain/controllers/ControllerContext';
import s from './Fees.scss';
import {TotalGroup} from '../TotalGroup/TotalGroup';
import {TotalUpdateSkeleton} from '../TotalUpdateSkeleton';
import {FeeModel} from '../../../../../../../domain/models/CartSummary/Fee.model';

export enum FeesDataHook {
  Root = 'Fees.Root',
  Price = 'Fees.Price',
}

export const Fees = ({
  shouldShowDivider,
  fees,
  groupTitle,
}: {
  shouldShowDivider: boolean;
  fees: FeeModel[];
  groupTitle: string;
}) => {
  const {isSummaryUpdating} = useControllerProps().cartStore;

  return (
    <div className={shouldShowDivider && fees.length > 1 ? s.bottomDivider : undefined}>
      <TotalGroup
        dataHook={FeesDataHook.Root}
        totals={fees.map((fee) => ({
          title: fee.name,
          value: isSummaryUpdating ? () => <TotalUpdateSkeleton /> : fee.price.formattedConvertedAmount,
          key: fee.code,
          additionalAttributes: {'data-wix-additional-fees-price': FeesDataHook.Price},
        }))}
        title={groupTitle}
      />
    </div>
  );
};
